import { logStartGreyError } from 'owa-analytics-start';
import type {
    NavigatorWithStorageBuckets,
    StorageBucketOptions,
    StorageBucket,
} from './StorageBucket';
import { INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT } from 'owa-analytics-types';

export async function getStorageBucket(
    name: string,
    options: StorageBucketOptions = { persisted: true, durability: 'relaxed' }
): Promise<StorageBucket | null> {
    const nav = navigator as NavigatorWithStorageBuckets;

    if (!nav.storageBuckets?.open) {
        return null;
    }

    try {
        const bucket = await nav.storageBuckets.open(name, options);
        return bucket;
    } catch (error) {
        // Using getGlobalSettingsAccountMailboxInfo: This is infrastructure telemetry about
        // storage bucket errors. This runs at storage initialization level
        // before user data context is established.
        // Errors resulting from enabling useUnknownInCatchVariables
        logStartGreyError(
            'GetStorageBucket',
            /* eslint-disable-next-line owa-custom-rules/telemetry-no-global-account-routing -- (https://aka.ms/OWALintWiki)
            This is used only for when the data worker is initialized */
            INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT,
            error as Error
        );
        return null;
    }
}
